import { render, staticRenderFns } from "./PaymentStatusPage.vue?vue&type=template&id=e680b9c2&"
import script from "./PaymentStatusPage.vue?vue&type=script&lang=js&"
export * from "./PaymentStatusPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports